






































/* Created- 29 - Aug - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SubscriberDetailsDTO } from "../../../Generated/ParticaAPI";
import { FormFieldProps, FormFieldRules, IFormField } from "../../../Models/Components.model";
import ParticaBaseForm from "../../Base/ParticaBaseForm.vue";
@Component(
	{
		name: "SubscriberDetails"
	})
export default class SubscriberDetails extends ParticaBaseForm<SubscriberDetailsDTO> {
	private idconfig =
		{
			props: {
				name: "id",
				placeholder: "Auth0 Id",
				label: "Auth0 Id",
				disabled: true
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;
	private emailconfig =
		{
			props: {
				name: "email",
				placeholder: "Email",
				label: "Subscriber Email",
				disabled: true
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;
	private expiryconfig =
		{
			props: { name: "expiryDate", placeholder: "expiryDate", label: "Subscriber Expiry Date", } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;
	private expiryDate: string = new Date().toISOString().substr(0, 10);
	private showpicker: boolean = false;
	@Watch("expiryDate")
	private setissueDateModel(date: string) {
		this.model.expiry = new Date(date);
	}
	@Watch("model")
	private setExpiryDate(obj: SubscriberDetailsDTO) {
		if (obj.expiry !== undefined) {
			this.expiryDate = this.model.expiry.toISOString().substr(0, 10);
		}
	}
	private mounted() {
		if (this.model.expiry !== undefined) {
			this.expiryDate = this.model.expiry.toISOString().substr(0, 10);
		}
	}
}
